// removed by extract-text-webpack-plugin
module.exports = {"tableText":"styles__tableText___Drnqy","tableTitle":"styles__tableTitle___27yxT","tableRow":"styles__tableRow___1vU30"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tChart/styles.css
// module id = 883
// module chunks = 0